export const ROUTES = {
    // YII2
    HOME: () => "/video/index",
    LOGIN: () => "/site/login",
    LOGOUT: () => "/site/logout",
    SIGNIN: () => "/site/account-activate",
    ADMIN_AREA: () => "/admin/index",
    CLIENT_AREA: () => "/superadmin/index",
    VIEW_ACCOUNT: () => "/site/accountview",
    PROFILE_MANAGEMENT: () => "/admin/tag",
    FASTCHANNEL_MANAGEMENT: () => "/admin/fastchannelmanager",
    VIEWFOLDER: (id) => `/video/viewfolder?rel=${id}&dm=9`,
    VIEWMEDIA: (id) => `/video/viewmedia?rel=${id}&relpl=1&dm=12&cntr=0&cntrl=0`,
    VIEWINTERMIDIATE: (id, playlistId) => `/video/viewintermediate?rel=${id}&relpl=${playlistId ?? 1}&dm=${playlistId ? 13 : 1}&cntr=0&cntrl=0`,
    VIEWINTERMIDIATEPAY: (id, playlistId) => `/video/viewintermediate?rel=${id}&relpl=${playlistId ?? 1}&dm=${playlistId ? 13 : 1}&cntr=0&cntrl=0&own=false`,
    SUBSCRIBTION: (contentId) => `/subscriptions/subscriptions-selection${contentId != undefined ? `?video_id=${contentId}` : ""}`,
    // REACT
    WATCH_VIDEO: (id, category, isPlaylist, playlistRel) => `/video/watch-video?rel=${id}&cat=${category}${isPlaylist ? `&prel=${playlistRel}` : ""}`,
    WATCH_REEL: (id, playlistId) => `/video/reel?rel=${id}&relpl=${playlistId ?? 1}&dm=${playlistId ? 13 : 1}&cntr=0&cntrl=0`,
};
